<template>
  <div class="page-content--body">

    <div class="page-content--body-right">
      <div class="block-wrap pb-8">
        <v-btn class="btn-blue with-icon mb-3 mob-100" color="primary">
          <span>Добавить объект</span>
        </v-btn>

        <div class="my-works">
          <div class="my-works--cards">
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-green">
                  Подтвержден
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта, может быть даже длинное</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img05.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog1"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-grey">
                  Не потдтержден
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта, может быть даже длинное длинное длинное длинное</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img04.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog2"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-orange">
                  Ожидает подтверждения
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта,</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img03.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog3"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-red">
                  Отклонен
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта,</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img02.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog4"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-blue">
                  Подтверждается
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта,</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img01.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва</span>
              </div>
              <v-dialog
                v-model="dialog5"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-grey">
                  Не потдтержден
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта, может быть даже длинное длинное длинное длинное</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img04.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog2"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-blue">
                  Подтверждается
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта,</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img01.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва</span>
              </div>
              <v-dialog
                v-model="dialog6"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-red">
                  Отклонен
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта,</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img02.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog7"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-orange">
                  Ожидает подтверждения
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта,</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img03.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog8"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-grey">
                  Не потдтержден
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта, может быть даже длинное длинное длинное длинное</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img04.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog9"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div class="my-works--cards-point">
              <div class="my-works--cards-point-status">
                <div class="my-works--cards-point-status--label label-green">
                  Подтвержден
                </div>
                <div class="my-works--cards-point-status--button">
                  <v-btn icon class="more-btn">
                    <img src="@/assets/images/ico-points.svg" alt="">
                  </v-btn>
                </div>
              </div>
              <div class="my-works--cards-point-title">Тут будет описание объекта, может быть даже длинное</div>
              <div class="my-works--cards-point-img">
                <img src="../../../assets/images/portfolio-img05.jpg" alt="">
              </div>
              <div class="my-works--cards-point-location">
                <img src="@/assets/images/ico-location.svg" alt="">
                <span>Москва </span>
              </div>
              <v-dialog
                v-model="dialog10"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="my-works--cards-point-more"
                  >
                    Подробнее
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="card-title">
                    Добавление / изменение объекта
                  </v-card-title>
                  <v-card-text>
                    Контент находится в стадии разработке
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </div>
      </div>
      <div class="text-xs-center">
        <v-pagination
          v-model="page"
          :length="10"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page3',
  data() {
    return {
      page: 1,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialog7: false,
      dialog8: false,
      dialog9: false,
      dialog10: false,
    };
  },
  computed: {

  },

  methods: {

  },
};
</script>

<style lang="scss" src="./page3.scss"/>
